/** This component will act as the main styled component that
 * we can extend to create styled SVGs
 */
import styled from 'styled-components';

export default styled.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
})``;
